import { FakeDoorType, Product } from "~/common/props/orchestrator";
import { useAnalytics, ITheme, ASSETS_URL } from "@commons-monorepo/index";
import { useEffect, useState } from "react";
import { EVENTS } from "~/constants/events";
import FloatingButtonCart from "./components/FloattingButtonCart/FloatingButtonCart";
import { useTranslation } from "react-i18next";
import EmptyState from "~/components/empty-states/empty-state/empty-state";
import { GiftCard } from "~/components/GiftCard/GiftCard";
import BannerOtherMerchan from "~/modules/ads-suggestions/components/banner-other-merchants/banner-other-merchants";
import { useAppSearchParams } from "@commons-monorepo/index";
import SuggestForYourAds from "~/modules/ads-suggestions/components/suggest-for-your-ads/suggest-for-your-ads";
import { camelizeKeys, decamelizeKeys } from "humps";
import SchemaGraph from "./components/schema-graph";
import styles from "./Catalogue.module.css";
import {
  getApiUrl,
  getEnvVar,
  useSessionStorage } from
"@commons-monorepo/index";
import { KEYS } from "~/common/constants/storage-keys";
import { useOutletContext } from "@remix-run/react";
import { normalizeUrl } from "@commons-monorepo/index";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { Widgets } from "~/components/widgets/widgets";
import { HomeWidget, WidgetType } from "@commons-monorepo/index";
import ScrollToTop from "~/components/button-scroll-to-top";
import AllianceTag from "~/components/alliance-tag/alliance-tag";

const Catalogue = ({
  products,
  theme,
  widgets




}: {products: Product[];theme: ITheme;widgets: HomeWidget[];}) => {
  const { t } = useTranslation();
  const [searchParams] = useAppSearchParams();
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const tokenPersonalization = searchParams.get("token");
  const enabledConfiguration =
  storeMetadata?.configuration?.enabledConfiguration;
  const addCardProductFixed =
  storeMetadata.abCartAddProduct?.treatment === "on";
  const { cartProducts } = useCart();
  const giftCardUrl = storeMetadata?.fakeDoor?.find(
    (item: any) => item[FakeDoorType.URL_GIFT_CARD]
  );
  const [pageHasBeenVisited, setSessionStorage] = useSessionStorage(
    KEYS.PAGE_HAS_BEEN_VISITED,
    false
  );
  const storeIsPrime = storeMetadata?.prime?.id !== undefined;
  const [scheduleResume, setScheduleResume] = useState("");

  useEffect(() => {
    let templateProperties = decamelizeKeys({
      templateId: theme.templateId,
      headerId: theme.template.HEADER,
      bannerId: theme.template.COVER,
      categoriesId: theme.template.CATEGORIES,
      cardId: theme.template.PRODUCT_CARD,
      footerId: theme.template.FOOTER,
      storeInfoId: theme.template.STORE_INFO.SKIN
    });

    if (tokenPersonalization) {
      templateProperties = { ...templateProperties, source: "personalization" };
    }

    if (pageHasBeenVisited) {
      logEvent(EVENTS.VIEW_STORE, {
        hasAdSense: `${!storeIsPrime}`,
        ...(addCardProductFixed ? { ab_test: "add_to_cart_fixed" } : {}),
        ...templateProperties
      });
    } else {
      setSessionStorage(true);
      templateProperties = {
        ...templateProperties,
        first_session_visit: true
      };
      logEvent(EVENTS.VIEW_STORE, {
        hasAdSense: `${!storeIsPrime}`,
        ...(addCardProductFixed ? { ab_test: "add_to_cart_fixed" } : {}),
        ...templateProperties
      });
    }
  }, [logEvent]);

  const showEmptyState =
  !products.length &&
  !widgets?.filter((widget) => widget.type !== WidgetType.PRODUCTS_GRID_1)?.
  length;

  useEffect(() => {
    if (enabledConfiguration && !enabledConfiguration.enabled) {
      fetch(
        `${getApiUrl()}/api/ms/user/user-detail/profile-url/${normalizeUrl(
          storeMetadata.userNetwork.urlSummer
        )}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "api-key-sumer": getEnvVar("PUBLIC_API_KEY")
          }
        }
      ).
      then((res) => res.json()).
      then((res) => camelizeKeys(res)).
      then((res) => {
        const resume = res?.userDetail?.scheduleConfiguration?.resume;
        setScheduleResume(resume);
        return res;
      }).
      catch((err) => {
        return {};
      });
    }
  }, [enabledConfiguration]);

  return (
    <div
      className={`${styles.wrapperCatalogue} ${styles.catalogueContainer}`}
      role={"content-catalogue-wrapper"}>

      {!tokenPersonalization && <BannerOtherMerchan />}
      <div id={"products"} className={styles.contentCatalogue}>
        {enabledConfiguration && !enabledConfiguration.enabled &&
        <div className={styles.storeClosed} role={"store-closed"}>
            <div className={styles.storeClosedHeader}>
              <div className={styles.storeClosedHeaderTitle}>
                <div className='icon-clock' />
                <div className={styles.storeClosedHeaderInfo}>
                  {t("disabledStore.closedNowCopy")}
                </div>
              </div>
              <img
              className={styles.storeClosedImg}
              src={`${ASSETS_URL}/prod/assets/web/catalogue/icons/clock.png`}
              alt='store-closed' />

            </div>
            <h5 className={styles.storeClosedDisabledCopy}>
              {enabledConfiguration?.disabledCopy}
            </h5>
            <p className={styles.storeClosedDisabledResume}>{scheduleResume}</p>
          </div>}

      </div>
      {giftCardUrl &&
      <div className={styles.contentCatalogue}>
          <GiftCard url={giftCardUrl} />
        </div>}


      <SuggestForYourAds />
      {!showEmptyState && <Widgets products={products} widgets={widgets} />}
      {showEmptyState && theme.templateId !== "MADRID" &&
      <EmptyState searchProduct />}

      <ScrollToTop />
      {
      storeMetadata?.externalId && <AllianceTag allianceName={storeMetadata?.externalId} />}

      <div>{cartProducts.length >= 1 && <FloatingButtonCart />}</div>
      <SchemaGraph storeMetadata={storeMetadata} />
    </div>);

};
export default Catalogue;